import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, errorMessage } from '../../context/AuthContext';
import SubjectPicker from '../../components/SubjectPicker';

// Liste des sujets de QCM + ajout d'un sujet
export default function AdminQcm() {
  const { authFetch } = useAuth();
  const [subjects, setSubjects] = useState([]);
  const [loadError, setLoadError] = useState(false);
  const [form, setForm] = useState({ name: '', description: '' });
  const [flash, setFlash] = useState(null);

  const load = () => authFetch('/api/admin/qcm/subjects')
    .then(r => r.ok ? r.json() : Promise.reject())
    .then(d => { setSubjects(d); setLoadError(false); })
    .catch(() => setLoadError(true));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const add = async (e) => {
    e.preventDefault();
    setFlash(null);
    try {
      const r = await authFetch('/api/admin/qcm/subjects', { method: 'POST', body: JSON.stringify(form) });
      if (!r.ok) throw new Error(await errorMessage(r));
      setForm({ name: '', description: '' });
      setFlash({ type: 'ok', text: `✓ sujet « ${form.name} » ajouté` });
      setTimeout(() => setFlash(null), 2500);
      load();
    } catch (err) {
      setFlash({ type: 'error', text: `Sujet non ajouté : ${err.message}` });
    }
  };

  return (
    <div>
      <h1 style={{ fontStyle: 'italic', marginBottom: '.5rem' }}>QCM</h1>
      <p style={{ color: 'var(--ink-soft)', marginBottom: '2rem' }}>
        Les QCM sont rangés par sujet. Ouvrez un sujet pour ajouter, importer (CSV), modifier ou supprimer ses QCM.
      </p>

      {flash && <div className={`flash ${flash.type === 'error' ? 'error' : ''}`}>{flash.text}</div>}

      <form onSubmit={add} className="qcm-panel" style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.3rem', marginBottom: '1rem' }}>+ Nouveau sujet</h2>
        <div className="qcm-grid-2">
          <div className="form-group">
            <label>Nom du sujet</label>
            <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="ex : Mathématiques, Culture générale…" required />
          </div>
          <div className="form-group">
            <label>Description (facultative)</label>
            <input value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
          </div>
        </div>
        <button className="btn" type="submit">ajouter le sujet</button>
      </form>

      <SubjectPicker subjects={subjects.map(s => ({ id: s.id, name: s.name, count: s.quiz_count }))} allHref="/admin/qcm" hrefFor={sid => `/admin/qcm/sujets/${sid}`} unit="QCM" />
      <div className="admin-list">
        {loadError && <div className="flash error">Impossible de charger les sujets — rechargez la page.</div>}
        {!loadError && subjects.length === 0 && <div className="empty-state">aucun sujet pour l'instant.</div>}
        {subjects.map(s => (
          <div className="admin-row" key={s.id}>
            <div>
              <div className="admin-row-title">{s.name}</div>
              <div style={{ fontSize: '.8rem', color: 'var(--ink-soft)', fontFamily: 'var(--font-mono)' }}>
                {s.quiz_count} QCM · {s.published_count} publié(s){s.description && ` · ${s.description}`}
                {s.quiz_count > 0 && s.published_count === 0 && <span className="qcm-status"> · ○ aucun QCM visible sur le site</span>}
                {s.quiz_count === 0 && <span className="qcm-status"> · ○ sujet vide, non affiché sur le site</span>}
              </div>
            </div>
            <div className="admin-row-actions">
              <Link to={`/admin/qcm/sujets/${s.id}`} className="btn">ouvrir →</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
